module.exports = __webpack_public_path__ + "static/media/warning.37d6ab9e.svg";